import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { RelatorioEntradasSaidasCategoriaRequest } from '../../requests/financas/relatorio-entradas-saidas-categoria.request';
import { SaveRelatorioFiltroFavoritoRequest } from '../../requests/financas/save-relatorio-filtro-favorito.request';
import { SaveRelatorioFiltroFavoritoResponse } from '../../responses/financas/relatorio-filtro-favorito.response';
import {
    RelatorioEntradasSaidasCategoriaLookupResponse,
    RelatorioEntradasSaidasCategoriaResponse
} from '../../responses/financas/relatorio-entradas-saidas-categoria.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class RelatorioEntradasSaidasCategoriaService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}RelatorioEntradasSaidasCategoria`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLookup(): Observable<RelatorioEntradasSaidasCategoriaLookupResponse> {
        return this.httpClient
            .get<RelatorioEntradasSaidasCategoriaLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getPreview(request: RelatorioEntradasSaidasCategoriaRequest): Observable<RelatorioEntradasSaidasCategoriaResponse> {
        return this.httpClient
            .post<RelatorioEntradasSaidasCategoriaResponse>(`${this.apiUrl}/preview`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public saveFavorito(request: SaveRelatorioFiltroFavoritoRequest): Observable<SaveRelatorioFiltroFavoritoResponse> {
        return this.httpClient
            .post<SaveRelatorioFiltroFavoritoResponse>(`${this.apiUrl}/favorito`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteFavorito(idRelatorioFiltroFavorito: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/favorito/${idRelatorioFiltroFavorito}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
